(function () {
  'use strict';

  function smoothScrollTo(target) {
    if (!target) return;
    var header = document.querySelector('sticky-header, .header-wrapper, header');
    var offset = header ? header.getBoundingClientRect().height + 12 : 80;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-lnu-scroll]');
    if (!trigger) return;
    var hash = trigger.getAttribute('href');
    if (!hash || hash.charAt(0) !== '#') return;
    var target = document.querySelector(hash);
    if (!target) return;
    e.preventDefault();
    smoothScrollTo(target);
    history.replaceState(null, '', hash);
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

  var selectors = [
    '[data-banned-card]',
    '.lnu-deep-row',
    '.lnu-suitable-card',
    '.lnu-compare-col',
    '.lnu-intent__body',
    '.lnu-intent__media'
  ];
  document.querySelectorAll(selectors.join(',')).forEach(function (el) {
    observer.observe(el);
  });
})();
